import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as $ from 'jquery'
import 'popper.js'
import 'bootstrap'
import './assets/scss/app.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhone,faEnvelope,faCouch,faCoffee,faDesktop,faBook,faBed,faTshirt,faHome,faBath,faAlignLeft} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
 
library.add(faPhone, faEnvelope,faCouch,faCoffee,faDesktop,faBook,faBed,faTshirt,faHome,faBath,faAlignLeft  )
 
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
